import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { WithTheme } from './../../../setup/index'
import { transition } from './../../../common/Mixins'

const SlideArrowStyled = styled.div<WithTheme>`
  ${transition}

  &:hover {
    opacity: 0.7;
  }
  svg {
    width: 1.625rem;
    font-size: 1.625rem;
    color: currentColor;
  }

  .slick-arrow {
    color: ${({ theme }) => theme.colors.green};
  }
  .slick-prev,
  .slick-next {
    &:before {
      display: none;
    }
  }

  .slick-disabled {
    opacity: 0.2;
  }

  ${({ theme }) =>
    theme.direction === 'rtl'
      ? css`
          .slick-prev {
            right: 3rem;
            left: auto;
          }
          .slick-next {
            right: 0.5rem;
            left: auto;
          }
        `
      : ''}

  ${({ isRotated }) =>
    isRotated &&
    css`
      svg {
        transform: rotate(180deg);
      }
    `}
`

const SlideArrowItemStyled = styled.div<WithTheme>`
  display: flex;
  color: ${({ theme }) => theme.colors.green};
`

export { SlideArrowStyled, SlideArrowItemStyled }
